import { useState } from "react";
import Slider from "./Slider";

## Basic Usage

Uncontrolled with a default value. `value`/`defaultValue` are arrays (`number[]`).

<div style={{ maxWidth: "320px" }}>
  <Slider defaultValue={[30]} />
</div>

---

## Controlled

export function ControlledSlider() {
  const [value, setValue] = useState([40]);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxWidth: "320px" }}>
      <Slider value={value} onValueChange={setValue} />
      <span>Value: {value[0]}</span>
    </div>
  );
}

<ControlledSlider />

---

## Range (two thumbs)

Pass two values for a range selection, and name each endpoint with `getThumbAriaLabel` (a
root-level `aria-label` names the slider group, not the individual thumb inputs).

export function RangeSlider() {
  const [range, setRange] = useState([25, 75]);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxWidth: "320px" }}>
      <Slider
        value={range}
        onValueChange={setRange}
        getThumbAriaLabel={(index) => (index === 0 ? "Minimum" : "Maximum")}
      />
      <span>
        Range: {range[0]} – {range[1]}
      </span>
    </div>
  );
}

<RangeSlider />

---

## Custom Min / Max / Step

export function SteppedSlider() {
  const [value, setValue] = useState([4]);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxWidth: "320px" }}>
      <Slider value={value} onValueChange={setValue} min={0} max={10} step={2} />
      <span>Value: {value[0]} (0–10, step 2)</span>
    </div>
  );
}

<SteppedSlider />

---

## Disabled

<div style={{ maxWidth: "320px" }}>
  <Slider defaultValue={[50]} disabled />
</div>
